import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchQualificationsFiltre } from 'store/qualification/qualificationActions';
import MultipleQualificationSelect from './MultipleQualificationSelect';
import withLoader from 'components/Shared/withLoader';

const MultipleQualificationSelectWithLoader = withLoader(MultipleQualificationSelect);

class MultipleQualificationSelectContainer extends React.Component {

    componentDidMount() {
        this.props.fetchQualificationsFiltre();
    }

    render() {
        const { categoriesQualifications, selected, isLoading, onChange, size } = this.props;

        return (
            <MultipleQualificationSelectWithLoader
                categoriesQualifications={categoriesQualifications}
                selected={selected}
                isLoading={isLoading}
                onChange={onChange}
                size={size}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        isLoading: state.qualification.qualificationsFiltre.isLoading,
        categoriesQualifications: state.qualification.qualificationsFiltre.items
    };
};


const mapDispatchToProps = dispatch => ({
    fetchQualificationsFiltre: () => dispatch(fetchQualificationsFiltre(false))
});

MultipleQualificationSelectContainer.propTypes = {
    selected: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleQualificationSelectContainer);